<template>
  <div class="dropdowns-container">
    <div class="dropdowns__item__wrapper">
      <div class="dropdowns__item__wrapper__content">
        <div class="dropdowns__item__wrapper__content__title">
          <slot />
          <span class="txt" :class="{ 'is-mobile': isMobile, up: open === 'up' }">{{ $t($capitalize(text)) }}</span>
        </div>
        <ul :class="open">
          <li
            v-for="option in options"
            :key="option.id"
            :class="{ active: option.id === innerValue, 'is-mobile': isMobile }"
            @click="selectOption(option)"
          >
            <img v-if="option.id" :src="getFlagUrl(option.id)" width="20" height="20" />
            <span class="country-label">{{ $t($capitalize(option.text)) }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { isMobile } from 'mobile-device-detect';

export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    defaultValue: {
      type: String,
      default: '',
    },
    open: {
      type: String,
      default: 'down',
    },
  },
  data: () => {
    return {
      text: '',
      innerValue: '',
      isMobile,
    };
  },
  emits: ['change', 'update:modelValue'],
  created() {
    if (this.defaultValue) {
      const defaultOption = this.options.find((option) => option.id === this.defaultValue) || {};
      if (defaultOption) {
        this.innerValue = defaultOption.id;
        this.text = defaultOption.text;
        this.$emit('update:modelValue', this.innerValue);
      }
    }
  },
  methods: {
    selectOption(option) {
      this.innerValue = option.id;
      this.text = option.text;
      this.$emit('update:modelValue', this.innerValue);
      this.$emit('change', option);
    },
    getFlagUrl(lang) {
      if (lang === 'zh') {
        return require('@/assets/svg/lang-flags/globe.svg');
      }
      return require(`@/assets/svg/lang-flags/${lang}.svg`);
    },
  },
  model: {
    prop: 'value',
    event: 'update:modelValue',
  },
};
</script>

<style lang="scss" scoped>
.dropdowns-container {
  position: relative;
  @include displayFlex;
  justify-content: flex-start;
  align-self: center;
  width: 100%;
  height: 100%;

  .dropdowns {
    &__item {
      &__wrapper {
        @include displayFlex;

        &__content {
          @include displayFlex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          padding: 0 8px;
          position: relative;

          &__title {
            @include alignJustifyCenter;
            @include user-select-none;

            & > img {
              @include user-select-none;
            }
          }

          > .icon {
            margin-right: 4px;
          }

          .txt {
            @include displayFlex;
            justify-content: space-around;
            align-items: center;
            min-width: 60px;
            font-size: 15px;
            line-height: 1.2;
            font-weight: 500;
            color: #fff;
            text-transform: uppercase;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-left: 12px;

            &.is-mobile {
              font-size: 13px;
            }

            &::after {
              content: '';
              display: block;
              width: 6px;
              height: 6px;
              margin: 8px 0 8px 8px;
              transform: scale(0.6) rotate(135deg);
              -webkit-transform: scale(0.6) rotate(135deg);
              transition: all 0.1s ease-in;
              border: 2px solid #fff;
              border-bottom: none;
              border-left: none;
            }

            &:hover {
              &::after {
                -ms-transform: scale(0.6) rotate(-45deg);
                transform: scale(0.6) rotate(-45deg);
                -webkit-transform: scale(0.6) rotate(-45deg);
                transition: all 0.1s ease-in;
                transform-origin: 50% 50%;
              }
            }

            &.up::after {
              content: '';
              display: block;
              width: 6px;
              height: 6px;
              margin: 8px 0 8px 8px;
              transform: scale(0.6) rotate(-45deg);
              -webkit-transform: scale(0.6) rotate(-45deg);
              transition: all 0.1s ease-in;
              border: 2px solid #fff;
              border-bottom: none;
              border-left: none;
            }

            &.up:hover {
              &::after {
                -ms-transform: scale(0.6) rotate(135deg);
                transform: scale(0.6) rotate(135deg);
                -webkit-transform: scale(0.6) rotate(135deg);
                transition: all 0.1s ease-in;
                transform-origin: 50% 50%;
              }
            }
          }

          ul {
            @include user-select-none;
            display: none;
            position: absolute;
            margin: 0;
            padding: 0;
            border-radius: 2px;
            box-sizing: border-box;
            border-radius: 8px;
            background-color: #102741;
            top: 100%;
            left: 0;
            z-index: 999;
            width: 100%;
            min-width: 180px;

            &.up {
              top: unset;
              bottom: 100%;
            }

            li {
              list-style: none;
              padding: 12px;

              @include displayFlex;
              justify-content: flex-start;
              flex-direction: row;
              align-items: center;
              height: 24px;
              font-size: 15px;
              color: #fff;
              text-transform: uppercase;

              &.is-mobile {
                font-size: 13px;
              }

              img {
                @include user-select-none;
                margin-right: 12px;
              }

              .country-label {
                line-height: 16px;
              }

              &:hover {
                color: #fff;
                background-image: linear-gradient(
                  to right,
                  rgba(91, 134, 175, 0.5),
                  rgba(91, 134, 175, 0.5) 43%,
                  rgba(108, 110, 115, 0) 96%
                );
              }

              &.active {
                color: #fff;
                background-image: linear-gradient(
                  to right,
                  rgba(91, 134, 175, 0.5),
                  rgba(91, 134, 175, 0.5) 43%,
                  rgba(108, 110, 115, 0) 96%
                );
              }
            }
          }

          &:hover {
            background-image: linear-gradient(
              to right,
              rgba(91, 134, 175, 0.5),
              rgba(91, 134, 175, 0.5) 43%,
              rgba(108, 110, 115, 0) 96%
            );
          }
        }

        &__con:last-child {
          padding-right: 0;
        }

        &:hover {
          ul {
            display: block;
          }
        }
      }
    }
  }
}
</style>
